import '../assets/NcRelatedResourcesPanel-D6K7OQFJ.css';
import c from "@nextcloud/axios";
import { generateOcsUrl as u } from "@nextcloud/router";
import { n as l } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import { C as p } from "./ChevronDown-HHJdUMN4.mjs";
import { C as m } from "./ChevronUp-B6TIgl1a.mjs";
import d from "../Components/NcButton.mjs";
import { N as _ } from "./NcIconSvgWrapper-BTdzvQGV.mjs";
import { r as o, M as f, a as n, N as h, O as v } from "./_l10n-BaNxGGXy.mjs";
import { g } from "./autolink-DNGB8YSW.mjs";
const y = {
  name: "AccountGroupIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var C = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon account-group-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(s) {
    return e.$emit("click", s);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, I = [], R = /* @__PURE__ */ l(
  y,
  C,
  I,
  !1,
  null,
  null,
  null,
  null
);
const b = R.exports, N = {
  name: "OpenInNewIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var $ = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon open-in-new-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(s) {
    return e.$emit("click", s);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, S = [], w = /* @__PURE__ */ l(
  N,
  $,
  S,
  !1,
  null,
  null,
  null,
  null
);
const O = w.exports;
o(f);
const V = {
  name: "NcTeamResources",
  components: {
    AccountGroup: b,
    ChevronDown: p,
    ChevronUp: m,
    OpenInNew: O,
    NcButton: d,
    NcIconSvgWrapper: _
  },
  props: {
    providerId: {
      type: String,
      default: null
    },
    itemId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    var r, e;
    return {
      appEnabled: ((r = OC == null ? void 0 : OC.appswebroots) == null ? void 0 : r.circles) !== void 0 && ((e = OC.config.version.split(".")[0]) != null ? e : 0) >= 29,
      loading: !1,
      teamResources: null,
      teamOpen: []
    };
  },
  computed: {
    isVisible() {
      var r;
      return !this.loading && ((r = this.teamResources) == null ? void 0 : r.length) > 0;
    },
    teamProviders() {
      return (r) => {
        var t;
        return (t = this.teamResources.find((s) => s.teamId === r).resources) == null ? void 0 : t.reduce((s, i) => (i.provider.id === this.providerId && i.id === String(this.itemId) || (s[i.provider.id] || (s[i.provider.id] = i.provider, s[i.provider.id].resources = []), i.provider.id === this.providerId && i.id === String(this.itemId)) || s[i.provider.id].resources.push(i), s), {});
      };
    },
    open() {
      return (r) => this.teamOpen.indexOf(r) !== -1;
    }
  },
  watch: {
    providerId() {
      this.fetchTeamResources();
    },
    itemId() {
      this.fetchTeamResources();
    }
  },
  created() {
    this.fetchTeamResources();
  },
  methods: {
    t: n,
    async fetchTeamResources() {
      var r;
      try {
        this.loading = !0;
        const e = await c.get(u("/teams/resources/".concat(this.providerId, "/").concat(this.itemId)));
        this.teamResources = e.data.ocs.data.teams, this.teamOpen = [(r = this.teamResources[0]) == null ? void 0 : r.teamId];
      } catch (e) {
        this.teamResources = null, console.error(e);
      } finally {
        this.loading = !1;
      }
    },
    toggleOpen(r, e) {
      e ? this.teamOpen.push(r) : this.teamOpen.splice(this.teamOpen.indexOf(r), 1);
    }
  }
};
var k = function() {
  var e = this, t = e._self._c;
  return e.appEnabled && e.isVisible ? t("div", { staticClass: "team-resources" }, [t("h5", { staticClass: "team-resources__header" }, [e._v(" " + e._s(e.t("Related team resources")) + " ")]), e._l(e.teamResources, function(s) {
    return t("details", { key: s.teamId, staticClass: "related-team", attrs: { name: "Team resources", open: e.open(s.teamId) }, on: { toggle: (i) => e.toggleOpen(s.teamId, i.target.open) } }, [t("summary", { staticClass: "related-team__header" }, [t("h5", { staticClass: "related-team__name" }, [t("AccountGroup", { attrs: { size: 20 } }), e._v(" " + e._s(s.displayName) + " ")], 1), t("NcButton", { attrs: { type: "tertiary", href: s.link, "aria-label": e.t("View team"), title: e.t("View team") }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [t("OpenInNew", { attrs: { size: 20 } })];
    }, proxy: !0 }], null, !0) }), e.open(s.teamId) ? t("ChevronUp", { attrs: { size: 20 } }) : t("ChevronDown", { attrs: { size: 20 } })], 1), t("div", e._l(e.teamProviders(s.teamId), function(i) {
      return t("div", { key: i.id, staticClass: "related-team-provider" }, [i.resources.length > 0 ? t("h6", [e._v(" " + e._s(i.name) + " ")]) : e._e(), t("ul", e._l(i.resources, function(a) {
        return t("li", { key: a.url, staticClass: "related-team-resource" }, [t("a", { staticClass: "related-team-resource__link", attrs: { href: a.url } }, [a.iconEmoji ? t("span", { staticClass: "resource__icon" }, [e._v(" " + e._s(a.iconEmoji) + " ")]) : a.iconSvg ? t("NcIconSvgWrapper", { staticClass: "resource__icon", attrs: { svg: a.iconSvg, size: 20 } }) : a.iconURL ? t("span", { staticClass: "resource__icon" }, [t("img", { attrs: { src: a.iconURL, alt: "" } })]) : e._e(), t("span", { staticClass: "resource__name" }, [e._v(" " + e._s(a.label) + " ")])], 1)]);
      }), 0)]);
    }), 0)]);
  })], 2) : e._e();
}, T = [], A = /* @__PURE__ */ l(
  V,
  k,
  T,
  !1,
  null,
  "018e1c98",
  null,
  null
);
const x = A.exports;
o(h);
const z = {
  name: "NcResource",
  components: {
    NcButton: d
  },
  props: {
    icon: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    url: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      labelTranslated: n('Open link to "{resourceName}"', { resourceName: this.name })
    };
  },
  computed: {
    route() {
      return g(this.$router, this.url);
    }
  },
  methods: {
    t: n
  }
};
var H = function() {
  var e = this, t = e._self._c;
  return t("li", { staticClass: "resource" }, [t("NcButton", { staticClass: "resource__button", attrs: { "aria-label": e.labelTranslated, type: "tertiary", to: e.route, href: e.route ? null : e.url }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t("div", { staticClass: "resource__icon" }, [t("img", { attrs: { src: e.icon } })])];
  }, proxy: !0 }]) }, [e._v(" " + e._s(e.name) + " ")])], 1);
}, M = [], E = /* @__PURE__ */ l(
  z,
  H,
  M,
  !1,
  null,
  "dd53e5b9",
  null,
  null
);
const B = E.exports;
o(v);
const F = {
  name: "NcRelatedResourcesPanel",
  components: {
    NcResource: B,
    NcTeamResources: x
  },
  props: {
    /**
     * The provider id implemented with `\OCA\RelatedResources\IRelatedResourceProvider::getProviderId()`
     */
    providerId: {
      type: String,
      default: null
    },
    /**
     * The item id which uniquely identities the e.g. Calendar event, Deck board, file, Talk room, etc.
     */
    itemId: {
      type: [String, Number],
      default: null
    },
    /**
     * Limits to specific resource type. i.e. any provider id implemented with `\OCA\RelatedResources\IRelatedResourceProvider::getProviderId()`
     */
    resourceType: {
      type: String,
      default: ""
    },
    /**
     * Set the maximum number of resources to load
     */
    limit: {
      type: Number,
      default: 0
    },
    /**
     * Only used by the files sidebar
     *
     * File info is passed when registered with `OCA.Sharing.ShareTabSections.registerSection()`
     */
    fileInfo: {
      type: Object,
      default: null
    },
    /**
     * Make the header name dynamic
     */
    header: {
      type: String,
      default: n("Related resources")
    },
    description: {
      type: String,
      default: n("Anything shared with the same group of people will show up here")
    },
    /**
     * If this element is used on a primary element set to true for primary styling.
     */
    primary: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "has-error",
    "has-resources"
  ],
  data() {
    var r;
    return {
      appEnabled: ((r = OC == null ? void 0 : OC.appswebroots) == null ? void 0 : r.related_resources) !== void 0,
      loading: !1,
      error: null,
      resources: []
    };
  },
  computed: {
    isVisible() {
      var r;
      return this.loading ? !1 : (r = this.error) != null ? r : this.resources.length > 0;
    },
    subline() {
      return this.error ? n("Error getting related resources. Please contact your system administrator if you have any questions.") : this.description;
    },
    hasResourceInfo() {
      return this.providerId !== null && this.itemId !== null || this.fileInfo !== null;
    },
    isFiles() {
      var r;
      return ((r = this.fileInfo) == null ? void 0 : r.id) !== void 0;
    },
    url() {
      let r = null, e = null;
      return this.isFiles ? (r = "files", e = this.fileInfo.id) : (r = this.providerId, e = this.itemId), u("/apps/related_resources/related/{providerId}?itemId={itemId}&resourceType={resourceType}&limit={limit}&format=json", {
        providerId: r,
        itemId: e,
        resourceType: this.resourceType,
        limit: this.limit
      });
    }
  },
  watch: {
    providerId() {
      this.fetchRelatedResources();
    },
    itemId() {
      this.fetchRelatedResources();
    },
    fileInfo() {
      this.fetchRelatedResources();
    },
    error(r) {
      this.$emit("has-error", !!r);
    },
    resources(r) {
      this.$emit("has-resources", r.length > 0);
    }
  },
  created() {
    this.fetchRelatedResources();
  },
  methods: {
    t: n,
    async fetchRelatedResources() {
      var r;
      if (!(!this.appEnabled || !this.hasResourceInfo)) {
        this.loading = !0, this.error = null, this.resources = [];
        try {
          const e = await c.get(this.url);
          this.resources = (r = e.data.ocs) == null ? void 0 : r.data;
        } catch (e) {
          this.error = e, console.error(e);
        } finally {
          this.loading = !1;
        }
      }
    }
  }
};
var L = function() {
  var e = this, t = e._self._c;
  return t("div", [t("NcTeamResources", { attrs: { "provider-id": e.providerId, "item-id": e.itemId } }), e.appEnabled && e.isVisible ? t("div", { staticClass: "related-resources" }, [t("div", { staticClass: "related-resources__header" }, [t("h5", [e._v(e._s(e.header))]), t("p", [e._v(e._s(e.subline))])]), e._l(e.resources, function(s) {
    return t("NcResource", { key: s.itemId, staticClass: "related-resources__entry", attrs: { icon: s.icon, name: s.title, url: s.url } });
  })], 2) : e._e()], 1);
}, P = [], U = /* @__PURE__ */ l(
  F,
  L,
  P,
  !1,
  null,
  "8855c164",
  null,
  null
);
const X = U.exports;
export {
  X as N
};
